import React from 'react'
import Layout from '../components/UnifyLayout'
import Container from '../components/Container'
import PageTitle from '../components/PageTitle'
import ContactForm from '../components/ContactForm'
import NewsletterSignup from '../components/NewsletterSignup'
import SEO from '../components/SEO'

const Signup = ({ data }) => {
  return (
    <Layout>
      <SEO title="Contact" description="Contact Hempgrid" />
      <section className="container g-py-100">
        <div className="row g-mb-20">
          <div className="col-lg-6 g-mb-50">
            {/* Heading */}
            <h2 className="h1 g-color-black g-font-weight-700 mb-4">Sign Up Today</h2>
            <p className="g-font-size-18 mb-0">Hempgrid is working towards early availability in the near future. Leave us your info and let us know what you're most interested in and we'll be in touch with next steps.</p>
            {/* End Heading */}
          </div>
        </div>
        <ContactForm name="signup" />
      </section>

      <NewsletterSignup />
    </Layout>
  )
}

export default Signup
